import * as React from "react";
import { IImageGridProps } from ".";
import { ImageGridItemsContainerDiv, ImageGridWrapperDiv } from "./ImageGrid.styles";
import { ImageTile } from "./ImageTile";

const ImageGrid = ({ ImageTiles, OnImageTileClick }: IImageGridProps) => {
    return (
        <ImageGridWrapperDiv>
            <ImageGridItemsContainerDiv>
                {ImageTiles.map((imageTile) =>
                    <ImageTile
                        key={imageTile.ID}
                        ID={imageTile.ID}
                        ImageURL={imageTile.ImageURL}
                        Title={imageTile.Title}
                        OnClick={OnImageTileClick}
                        Selected={imageTile.Selected}
                    />,
                )}
            </ImageGridItemsContainerDiv>
        </ImageGridWrapperDiv>
    );
};

export default ImageGrid;
